import "./Page.scss";

import type * as React from "react";

interface PageProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: "row" | "column";
}

export const Page: React.FC<PageProps> = ({
  type = "column",
  className,
  children,
  id,
  ...otherProps
}) => {
  const classes = ["page", className, type].filter(Boolean).join(" ");

  return (
    <div id={id} className={classes} {...otherProps}>
      {children}
    </div>
  );
};

export default Page;
